// extracted by mini-css-extract-plugin
module.exports = {"postInspectionDiyTabCard":"_1u2tz","verified":"_1AQmo","notStarted":"_3sW8S","failed":"tHgHQ","unavailable":"_2FVOq","cardText":"_2a47h"};